var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payMentDetails" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            title: _vm.$t("data.payin_details"),
            visible: _vm.dialogTableVisible,
            width: "580px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTableVisible = $event
            },
            open: _vm.getDetailInfo,
          },
        },
        [
          _c("div", { staticClass: "total" }, [
            _c("div", { staticClass: "total-item" }, [
              _c("div", { staticClass: "total-title" }, [
                _vm._v(_vm._s(_vm.$t("data.paid")) + ":"),
              ]),
              _c("div", { staticClass: "total-num color-main-linear-blue" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$store.getters.currency) +
                    " " +
                    _vm._s(
                      _vm._f("toDivideWithDot")(
                        _vm.merchantInfo.transaction_amount
                      )
                    )
                ),
              ]),
            ]),
            _c("div", { staticClass: "total-item" }, [
              _c("div", { staticClass: "total-title" }, [
                _vm._v(_vm._s(_vm.$t("data.fee")) + ":"),
              ]),
              _c("div", { staticClass: "total-num color-main-linear-blue" }, [
                _vm._v(
                  _vm._s(_vm.$store.getters.currency) +
                    " " +
                    _vm._s(
                      _vm._f("toDivideWithDot")(_vm.merchantInfo.fee_split)
                    )
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "section-title mb-12 mt-12" }, [
            _vm._v(" " + _vm._s(_vm.$t("data.timeline")) + " "),
          ]),
          _c("div", { staticClass: "line-bottom-1px" }),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("data.payin_created"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.transaction_create_time)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("data.payin_completed"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.transaction_return_time)),
            ]),
          ]),
          _vm.merchantInfo.transaction_status ===
          _vm.TRANSACTION_STATUS["success"]
            ? _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("data.estimated_settlement_time"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.merchantInfo.estimated_settlement_time || "/")
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm.merchantInfo.transaction_status ===
          _vm.TRANSACTION_STATUS["success"]
            ? _c("div", { staticClass: "item" }, [
                _c("div", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("data.actual_settlement_time"))),
                ]),
                _c("div", { staticClass: "content-gray" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.merchantInfo.actual_settlement_time || "/")
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "section-title mb-12 mt-36" }, [
            _vm._v(" " + _vm._s(_vm.$t("data.description")) + " "),
          ]),
          _c("div", { staticClass: "line-bottom-1px" }),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("customerService.transaction_id"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.transaction_id)),
            ]),
          ]),
          _vm.$store.getters.curCountry.country_code === "TH" &&
          _vm.merchantInfo.transaction_status === _vm.TRANSACTION_STATUS["void"]
            ? _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("customerService.void_transaction_id"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(
                    _vm._s(
                      _vm.merchantInfo.trans_void_resp &&
                        _vm.merchantInfo.trans_void_resp.void_no
                    )
                  ),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("customerService.merchant_order_id"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.merchant_order_id)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("operation.business_name"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.getRelatedInfo(_vm.merchantInfo, "business"))),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("operation.franchisee_name"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(
                _vm._s(_vm.getRelatedInfo(_vm.merchantInfo, "franchisee"))
              ),
            ]),
          ]),
          _vm.merchantInfo.settlement_status &&
          _vm.merchantInfo.transaction_status ===
            _vm.TRANSACTION_STATUS["success"]
            ? _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("data.settlement_status"))),
                ]),
                _c("div", { staticClass: "content-gray" }, [
                  _c("span", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getTransactionSettlementStatusMap(
                            _vm.merchantInfo.settlement_status
                          ).label
                        )
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm.$store.getters.curCountry.country_code === "TH" &&
          _vm.merchantInfo.transaction_status === _vm.TRANSACTION_STATUS["void"]
            ? _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("customerService.void_complete_time"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(
                    _vm._s(
                      _vm.merchantInfo.trans_void_resp &&
                        _vm.merchantInfo.trans_void_resp.void_complete_time
                    )
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.merchantInfo.channel_reference_no
            ? _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        _vm.$store.getters.isMX
                          ? "customerService.ph_invoice_no"
                          : "customerService.invoice_no"
                      )
                    )
                  ),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(_vm._s(_vm.merchantInfo.channel_reference_no)),
                ]),
              ])
            : _vm._e(),
          [2].includes(_vm.merchantInfo.pay_product_type)
            ? _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("customerService.payment_code"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(_vm._s(_vm.merchantInfo.pay_data)),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("merchant.payment_channel"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.channel_code)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("merchantAccount.recipient_name"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(
                _vm._s(
                  _vm._f("strAesDecryptAndAsterisk")(
                    _vm.merchantInfo.payer_name
                  )
                )
              ),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("merchantAccount.recipient_mobile"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(
                _vm._s(
                  _vm._f("strAesDecryptAndAsterisk")(
                    _vm.merchantInfo.payer_mobile
                  )
                )
              ),
            ]),
          ]),
          _vm.merchantInfo.transaction_status === 2
            ? _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("customerService.refund_type"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(
                    _vm._s(
                      _vm.getRefundTypeMap(_vm.merchantInfo.refund_category)
                    )
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.merchantInfo.transaction_status === 2
            ? _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(
                    _vm._s(_vm.$t("customerService.cumulative_amount_refunded"))
                  ),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("toDivideWithDot")(
                        Math.abs(_vm.merchantInfo.total_refunded_amount)
                      )
                    )
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.merchantInfo.transaction_status === 2
            ? _c(
                "div",
                { staticClass: "item" },
                [
                  _c(
                    "span",
                    { staticClass: "item-left content-blue" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "customerService.remaining_refundable_order_amount"
                          )
                        ) + " "
                      ),
                      _c("el-tooltip", { attrs: { placement: "top" } }, [
                        _c(
                          "div",
                          {
                            staticStyle: { width: "300px" },
                            attrs: { slot: "content" },
                            slot: "content",
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("tips.remaining_refundable_amount_tip")
                                )
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "span",
                          [
                            _c("svg-icon", {
                              staticClass: "icon-question",
                              attrs: { "icon-class": "help-question" },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c("span", { staticClass: "content-gray" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("toDivideWithDot")(
                          Math.abs(_vm.merchantInfo.available_refund_amount)
                        )
                      )
                    ),
                  ]),
                  _c(
                    "el-tag",
                    {
                      staticClass: "payin-status tag-custom",
                      attrs: {
                        type: _vm.getPayTransactionStatusType(
                          _vm.merchantInfo.transaction_status
                        ),
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getPayTransactionStatusMap(
                              _vm.merchantInfo.transaction_status
                            )
                          )
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }